import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { AuthContext } from '../../../components/Context/Auth/auth.context';
// components
import Alert from '@mui/material/Alert';
import { AppContext } from 'src/components/Context/AppContext/app.context';
import { loginRequest } from 'src/components/services/httpServices';
import { SaveToken, SaveUserInfo } from 'src/components/services/storageService';
import Iconify from '../../../components/iconify';
// ----------------------------------------------------------------------
// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

// const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
//   props,
//   ref,
// ) {
//   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const { authDispatch } = useContext(AuthContext);
  const usernameRef = useRef('');
  const pswdRef = useRef('');
  const [loading, setLoading] = useState(false);
  const [loginStatus, setLoginStatus] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [vertical, setVertical] = useState('top');
  const [horizontal, setHorizontal] = useState('right');
  let { dataFetched, setDataFetched } = useContext(AppContext);
  useEffect(() => {
    setDataFetched(false);
    localStorage.clear();
  }, []);
  console.log('dataFetched:', dataFetched);
  const login = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await loginRequest(usernameRef.current.value, pswdRef.current.value);
    //  console.log('response LOgin', response);
    if (response != null) {
      //    console.log('myResponse:', response);
      setLoginStatus(true);
      setMessage('Success');
      setOpen(true);

      SaveToken(response.token);
      SaveUserInfo(
        response.name,
        response.userId,
        response.userRole,
        response.firstPasswordChanged,
        response.profilePicture,
        response.deptId
      );
      authDispatch({
        type: 'SIGNIN_SUCCESS',
        isAuthenticated: true,
        name: response.name,
        userId: response.userId,
        userRole: response.userRole,
        firstPasswordChanged: response.firstPasswordChanged,
        profilePicture: response.profilePicture,
        deptId: response.deptId,
      });

      if (response) {
        navigate('/app/dashboard');
      } else {
        navigate('/');
      }
    } else {
      // setMessage(response);
      //   console.log('Im in else:');
      setMessage('Enter vaild User Code and Password');
      setOpen(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    navigate('/app/dashboard', { replace: true });
  };

  return (
    <>
      <form noValidate onSubmit={login}>
        <Stack spacing={3}>
          <TextField name="email" label="User Name" inputRef={usernameRef} />

          <TextField
            name="password"
            label="Password"
            inputRef={pswdRef}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          {/* <Checkbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link> */}
        </Stack>

        <LoadingButton fullWidth size="large" type="submit" variant="contained">
          Login
        </LoadingButton>
      </form>
      {loginStatus ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
